import { useNavigate } from "react-router-dom"

import { ArrowLeft } from "lucide-react"

const Header = ({ preCheck: _ }) => {
    const navigate = useNavigate()

    return (
        <header className="bg-white border-b-2 border-gray-200 shadow-md sticky top-0 z-40">
            <div className="max-w-7xl mx-auto px-6 py-2 flex items-center">
                <div className="flex items-center space-x-4">
                    <button
                        onClick={() => navigate("/pre-checks")}
                        className="flex items-center space-x-2 px-4 py-2 bg-gray-100 hover:bg-gray-200 rounded-lg"
                    >
                        <ArrowLeft className="w-4 h-4" />
                        <span>Back</span>
                    </button>

                    <div className="h-6 w-px bg-gray-300" />

                    <h1 className="text-xl font-bold">TruCheck Detail</h1>
                </div>
            </div>
        </header>
    )
}

export default Header
